import React, { useEffect } from 'react';
import StandardLanding from '../../../shared/components/StandardLanding';
import FormAddEditRecord from '../../general/FormAddEditRecord';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { showDevelopment } from '../../general/action';
import { addDevelopmentRecord, editDevelopmentRecord } from '../action';

const Landing = () => {
    const { id } = useParams();
    const dispatch = useDispatch();

    useEffect(() => {
        if (id) {
            dispatch(showDevelopment(id, callback));
        }
    }, []);

    const callback = () => {

    };

    return (
        <StandardLanding>
            <div className="main-container content-crop">
                <div className="flex justify-between">
                    <p className="lg-title text-blue-10">GAD LECTURE</p>
                    <p className="md-title text-gray-20">Add new report here</p>
                </div>
                <div className="mt-2">
                    <FormAddEditRecord
                        addDevelopmentRecord={addDevelopmentRecord}
                        editDevelopmentRecord={editDevelopmentRecord}
                    />
                </div>
            </div>
        </StandardLanding>
    );
};

export default Landing;
